export default __webpack_public_path__ + "static/media/upload-file-active.c08d96d0.svg";